import type { AxiosError } from "axios";

/** Standard backend error payload returned by API endpoints. */
export interface BackendErrorPayload {
  errorCode: number;
  errorMessage: string;
  errorType: string;
  metadata: Record<string, string | number | boolean | null>;
  referenceId: string;
}

/** Axios error typed with the backend error payload. */
export type BackendAxiosError = AxiosError<BackendErrorPayload>;

/** Returns the backend error payload from an Axios error, if present. */
export const getBackendErrorPayload = (
  error: BackendAxiosError | null | undefined,
): BackendErrorPayload | null => {
  return error?.response?.data ?? null;
};

/** Returns the backend error message from an Axios error, if present. */
export const getBackendErrorMessage = (
  error: BackendAxiosError | null | undefined,
): string | null => {
  return getBackendErrorPayload(error)?.errorMessage ?? null;
};
